<template id="child">

  <div v-if="showModal" :style="cssProps">
      <div>
    <div class="modal d-flex flex-column">
      <h1>Select a Credit Card</h1>
        <!-- begin -->
      <div class="current-card d-flex flex-row" v-for="(card, index) in info.savedCardDetails" :key="index" @click="chooseCard(index)" :class="info.choosedCardIndex === index? 'active' : ''">
        <i :class="'fab fa-cc-' + getCardInfo(card.cardnumber).type"></i>
        <div class="global-container d-flex flex-column align-items-start justify-content-center">
          <span>{{getCardInfo(card.cardnumber).niceType}}</span>
          <div class="container-number d-flex flex-row justify-content-between">
            <div class="d-flex flex-row align-items-center">
              <div class="dot"></div>
              <div class="dot"></div>
              <div class="dot"></div>
              <div class="dot"></div>
            </div>
            <div class="d-flex flex-row align-items-center">
              <div class="dot"></div>
              <div class="dot"></div>
              <div class="dot"></div>
              <div class="dot"></div>
            </div>
            <div class="d-flex flex-row align-items-center">
              <div class="dot"></div>
              <div class="dot"></div>
              <div class="dot"></div>
              <div class="dot"></div>
              <span class="lastnum">{{card.cardnumber.slice(card.cardnumber.length - 5, card.cardnumber.length)}}</span>
            </div>
          </div>
        </div>
      </div>
      <!-- end -->
      <div class="d-flex justify-content-center btn-cancel" @click="hide">
      <button >
        <span>Cancel</span>
      </button>
      </div>
    </div>
    </div>
    
      
    <div class="modal-overlay"></div>
  </div>
  
</template>
<script>
import { mapState } from "vuex";
import creditCardType from 'credit-card-type';
export default {
  template: "#child",
  data() {
    return {
      showModal: false,
     
    };
  },
  computed: {
    ...mapState(['info']),
		cssProps() { return {
        '--main-color': this.info.color ? "#" + this.info.color : "#c12d39"
      }
    }
	},
  methods: {
    show() {
      this.showModal = true;
    },
    hide() {
      this.showModal = false;
      
    },
    convert(){
      // let parts = this.expirydate.split('/');
      // this.cardInfo.expirymonth = parts[0];
      // this.cardInfo.expiryyear = parts[1];
    },
    chooseCard(index){
      this.$emit('submit', index);
      // this.$store.commit('card.set', {index});
    },
    getCardInfo(cardnumber){
        let type = creditCardType(cardnumber)
        return type[0]
    },
  },
  created(){
  }
};
</script>
<style scoped>
button{
  border: none;
  outline: none;
  background: none;
}
.btn-cancel button
{
 margin-top: 40px;
	height: 48px;
	width: 160px;
	border: 1px solid var(--main-color);
	border-radius: 24px;
	background-color: #FFFFFF;
}
.btn-cancel span{
 
	opacity: 0.8;
	color: #000000;
	font-family: Poppins;
	font-size: 13px;
	font-weight: 500;
	line-height: 20px;
	text-align: center;
}

.container-current {
  padding-top: 24px;
}

.current-card {
  min-height: 76px;
  height: 76px;
  width: 333px;
  border: 1px solid rgba(0, 0, 0, 0.1);
  border-radius: 8px;
  background-color: #ffffff;
  padding: 14px;
  margin-top: 8px;
}
.current-card:first-child{
  margin-left: 0px;
}
.current-card i {
  height: 48px;
  width: 54px;
  opacity: 0.6;
  color: #000000;
  font-family: "Font Awesome 5 Brands";
  font-size: 40px;
  line-height: 48px;
  text-rendering: geometricPrecision;
}
.global-container {
  padding-left: 16px;
  width: 100%;
}
.global-container span:first-child {
  opacity: 0.8;
  color: #000000;
  font-family: Poppins;
  font-size: 16px;
  font-weight: bold;
  line-height: 25px;
}

.container-number {
  width: 50%;
}
.lastnum {
  opacity: 0.6;
  color: #000000;
  font-family: Poppins;
  font-size: 13px;
  font-weight: 500;
  line-height: 20px;
  margin-left: 5px;
}
.dot {
  -moz-border-radius: 50px/50px;
  -webkit-border-radius: 50px 50px;
  border-radius: 50px/50px;
  border: 1px solid rgba(0, 0, 0, 0.6);
  background-color: #ffffff;
  width: 5px;
  height: 5px;
  margin-left: 1px;
  opacity: 0.6;
}
.card
{
   
	height: 76px;
	width: 336px;
	border: 1px solid rgba(0,0,0,0.1);
	border-radius: 8px;
	background-color: #FFFFFF;
}

.modal {
   position: fixed;;
  left:0;
  top: 0;
  right: 0;
  bottom: 0;
  margin: auto;
  overflow-y:auto;
  padding: 48px;
  box-sizing: border-box;

  z-index: 5;

  height: 512px;
  width: 434px;
  border: 1px solid rgba(0, 0, 0, 0.1);
  border-radius: 8px;
  background-color: #ffffff;
}
.modal h1 {
 
	opacity: 0.8;
	color: #000000;
	font-family: Poppins;
	font-size: 24px;
	font-weight: 800;
	line-height: 35px;
	text-align: center;

}

.modal-overlay {
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5); /* Black background with opacity */
  z-index: 1;
}
input
{
     border: none;
  padding: 0;
  background: none;
  outline: none;
}

.active {
  background-color: var(--main-color) !important;
}
.active i {
  color: #ffffff !important;
}
.active span {
  color: #ffffff !important;
}
@media screen and (max-width: 600px)
{
  .modal{
    width: 100%;
    height: 80%;
    
  }
  .column-input
  {
    height: 80%;
  }
  .column-input input
  {
    width: 100%;
  }
  .button
    {
        flex-direction: column-reverse !important;
        justify-content: center !important;
        align-items: center !important;

    }
    .button button:first-child
    {
        width: 100%;
        margin-top: 10px;
    }
    .button button:last-child
    {
        width: 100%;
    }
  
}
</style>



// WEBPACK FOOTER //
// src/components/steps/modals/selectcard.vue